module.exports = __webpack_public_path__ + "static/media/teacher-comp-banner-x2.37fd3137.jpg";